import { isNewIdentifiant } from '@mairistem/tools';
import _ from 'lodash';
import React from 'react';
import { useHistory, useParams } from 'react-router';

import { baseUrlFront } from '@/routes';
import { useRegieStore } from '@/zustand';

const ConstitutionRegieRouter = ({ children = null }) => {
  const history = useHistory();
  const regie = useRegieStore((state) => state.regie);
  const selectedRegieId = regie?.identifiant;

  const route = `${baseUrlFront}/constitution`;

  const { identifiant }: { identifiant?: number | string } = useParams();
  const parsedIdentifiantURL =
    identifiant === ':identifiant'
      ? null
      : isNewIdentifiant(identifiant)
        ? identifiant
        : _.toNumber(identifiant);

  const identifiantRef = React.useRef<string | number>(
    identifiant === ':identifiant' ? selectedRegieId : parsedIdentifiantURL,
  );

  const redirectTo = React.useCallback(
    (id: string | number) => {
      const isIdValid = isNewIdentifiant(id) || _.isFinite(id) || id === ':identifiant';
      // On redirect seulement si on est pas déjà sur cette route
      if (isIdValid && parsedIdentifiantURL !== id) {
        history.push(`${route}/${id}`);
      }
    },
    [history, parsedIdentifiantURL, route],
  );

  // Si on a recliqué sur le point de menu alors qu'on y était déjà
  // On charge sur la régie qu'on a dans le localStorage
  React.useEffect(() => {
    if (
      identifiantRef?.current !== parsedIdentifiantURL &&
      !isNewIdentifiant(parsedIdentifiantURL)
    ) {
      // Si on a rien dans la route,
      // on prend ce qu'il y a dans la ref
      if (parsedIdentifiantURL === null) {
        redirectTo(identifiantRef.current);
      } else {
        redirectTo(parsedIdentifiantURL);
        identifiantRef.current = parsedIdentifiantURL;
      }
    }
  }, [history, parsedIdentifiantURL, redirectTo, selectedRegieId, route]);

  /**
   * Si on a changé de régie en étant dans la constitution
   * On charge sur la nouvelle régie
   *
   * /!\ Ne peut plus se passer hors création depuis qu'on a retiré le bouton
   * de changement de régie dans la FicheBar de la constitution
   * donc on commente la redirection pour le moment
   */
  React.useEffect(() => {
    if (identifiantRef.current !== selectedRegieId && !isNewIdentifiant(identifiantRef?.current)) {
      // redirectTo(selectedRegieId); // voir commentaire useEffect
      identifiantRef.current = selectedRegieId;
    }
  }, [history, redirectTo, selectedRegieId, route]);

  return _.isNil(parsedIdentifiantURL) ? null : children;
};

export default ConstitutionRegieRouter;
